
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import ServicesDropdown from './ServicesDropdown';
import { useNavigationUtils } from '@/hooks/useNavigationUtils';

interface DesktopNavigationProps {
  isServicesActive: boolean;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({ isServicesActive }) => {
  const { currentLanguage, getLocalizedPath } = useLanguage();
  const { isWhyFutureLevelActive, getWhyFutureLevelPath } = useNavigationUtils();
  const t = translations[currentLanguage];
  
  return (
    <nav className="hidden md:flex items-center space-x-8">
      <Link 
        to={`/${currentLanguage}`}
        className="text-gray-100 hover:text-purple-400 transition-colors font-future tracking-wide text-sm relative group"
      >
        <span>{t.home}</span>
        <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-purple-500/70 group-hover:w-full transition-all duration-300"></span>
      </Link>
      
      <ServicesDropdown
        isServicesActive={isServicesActive}
      />
      
      <Link 
        to={getWhyFutureLevelPath()}
        className={`text-gray-100 hover:text-purple-400 transition-colors font-future tracking-wide text-sm relative group ${
          isWhyFutureLevelActive() ? 'text-purple-400' : ''
        }`}
      >
        <span>{t.whyFutureLevel}</span>
        <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-purple-500/70 group-hover:w-full transition-all duration-300"></span>
      </Link>
      
      <Link 
        to={getLocalizedPath('blog')}
        className="text-gray-100 hover:text-purple-400 transition-colors font-future tracking-wide text-sm relative group"
      >
        <span>{t.blog}</span>
        <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-purple-500/70 group-hover:w-full transition-all duration-300"></span>
      </Link>
      
      <Link 
        to={getLocalizedPath('contact')}
        className="text-gray-100 hover:text-purple-400 transition-colors font-future tracking-wide text-sm relative group"
      >
        <span>{t.contact}</span>
        <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-purple-500/70 group-hover:w-full transition-all duration-300"></span>
      </Link>
    </nav>
  );
};

export default DesktopNavigation;
